"use client";

import { useEffect } from "react";

// ----------------------------------------------------------------------
// The two things every dialog owes its reader: Escape closes it, and the page
// behind it stops scrolling. EnrollmentModal carried this inline while the
// download / share modals had neither, so the same overlay behaved differently
// depending on which button opened it.
// ----------------------------------------------------------------------

export default function useModalDismiss(isOpen: boolean, onClose: () => void) {
  useEffect(() => {
    if (!isOpen) return;

    const onKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") onClose();
    };

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    document.addEventListener("keydown", onKeyDown);

    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen, onClose]);
}
